import { deserializeData } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { orbitalTrackDetailSchema } from '@src/deserialize/yup/orbitalTrack'
import graphql from '@src/graphql/query/getOrbitalTrackDetail'
import { OrbitalTrackDetail } from '@src/types/orbitalTrack'
import { useCallback, useState } from 'react'

const useGetOrbitalTrackDetail = (): Hook => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<OrbitalTrackDetail | null>(null)

  const fetch = useCallback(
    async (starID: string): Promise<Response> => {
      const response = await query({
        variables: {
          starId: starID
        }
      })

      const orbitalTrackDetail = deserializeData<OrbitalTrackDetail>(
        response,
        orbitalTrackDetailSchema
      )

      setData(orbitalTrackDetail)

      return {
        data: orbitalTrackDetail
      }
    },
    [query]
  )

  return {
    data,
    loading,
    fetch
  }
}

type Response = {
  data: OrbitalTrackDetail | null
}

type Hook = {
  data: OrbitalTrackDetail | null
  loading: boolean
  fetch: (starID: string) => Promise<Response>
}

export default useGetOrbitalTrackDetail
